export function pluralize(number: number, item: string, es?: boolean) {
  return `${number} ${pluralizeWord(number, item, es)}`;
}

export function pluralizeWord(number: number, item: string, es?: boolean) {
  return `${item}${number === 1 ? "" : es ? "es" : "s"}`;
}

export function plural({
  count,
  word,
  es,
  pluralizeHideNumberIfZero
}: {
  count: number;
  word: string;
  es?: boolean;
  pluralizeHideNumberIfZero?: Boolean;
}) {
  if (!pluralizeHideNumberIfZero && count === 0) {
    return pluralizeWord(count, word, es);
  }

  return pluralize(count, word, es);
}
